import { store } from 'Store/store'
import { bizgainOnboardingRoutes, launchState } from 'Features/bizgainOnboarding/constants';
import { AppService } from 'AppServices/appService';
const { getUserById } = new AppService();
import { BusinessProfilesHelper } from 'Helpers/businessProfilesHelper';
const  { getBusinessProfiles } = new BusinessProfilesHelper();
import { ApiService } from 'Features/bizgainOnboarding/services/apiService';
const { getUserSessionBusinessDetailsBySessionId } = new ApiService();

export const createImageFormDataRequest = (
  sessionId,
  templateId,
  imageFile,
  imageUrl,
  type,
  imageName,
  imageSource = 0,
  downloadLink = null
) => {
  let formData = new FormData();
  formData.append('SessionId', sessionId);
  formData.append('TemplateId', templateId);
  if(imageFile){
    formData.append('ImageFile', imageFile);
  }
  else if(imageUrl){
    formData.append('ImageUrl', imageUrl);
  }
  formData.append('ImageType', type);
  formData.append('ImageName', imageName);
  formData.append('ImageSource', imageSource);
  formData.append('DownloadLink', downloadLink);
  return formData;
};

export const getImageFileFromUrl = async (imageUrl) => {
  const response = await fetch(imageUrl, { origin: window.location.origin });
  return await response.blob();
};

export const clearBizgainState = () => {
  store.dispatch('resetPersistedState');
  localStorage.removeItem('lastVisitedRoute');
}

export const assignPostSignUpInitialFlowMeta = async (to) => {
  to.meta.stepCount = 2;
  switch (to.name) {
    /* Step No 1 */
    case bizgainOnboardingRoutes.AgeGenderTarget.name: to.meta.stepNumber = 1; break;
    case bizgainOnboardingRoutes.LocationTargeting.name: to.meta.stepNumber = 1; break;

    /* Step No 2 */
    case bizgainOnboardingRoutes.LinkAccounts.name: to.meta.stepNumber = 2; break;
    case bizgainOnboardingRoutes.Budget.name: to.meta.stepNumber = 2; break;
  }
}

export const fetchUserDetails = async (user) => {
  /*
     This method expects  User id to be set in user object
  */
  let id = (user && user.id);
  if (id) {
    var userDetails = await getUserById(id);
    user = { ...user, ...userDetails }
    await store.dispatch('setUser', user);
    let isRoimatic = true;
    let businessProfiles;
    if (!(user && user.businessProfiles)) {
      user.firstName = user.firstName;
      businessProfiles = await getBusinessProfiles(isRoimatic);
      user.businessProfiles = [];
      user.businessProfiles = businessProfiles;
    }
    await store.dispatch('setUser', user);
  }
}

export const updateBusinessDetailsFromDbSession = async (sessionId) => {
  let userSessionBusinessDetail = await getUserSessionBusinessDetailsBySessionId(sessionId);
  if (userSessionBusinessDetail && userSessionBusinessDetail.businessDetail) {
    await store.dispatch('updateBusinessDetails', userSessionBusinessDetail.businessDetail);
  }
}

export const redirectToBusinessProfile = async (user, from, redirect, next) => {
  /*
     If user is logged in and tries to access /signup
     Case 1. If there are multiple bps redirect to profile selection via login
     Case 2. If there is only one bp redirect to dashboard
  */
  if (user.businessProfiles.length > 1) {
    let redirectRoute = {
      name: 'login'
    };
    redirect(from, redirectRoute, next);
  } else {
    await store.dispatch(
      'setBusinessProfileId',
      user.businessProfiles[0].id
    );
    let redirectRoute = {
      name: 'dashboard',
      params: { businessProfileId: user.businessProfiles[0].id }
    };
    redirect(from, redirectRoute, next);
  }
}

export const getSelectObjectiveRedirectRouteObj = (isInAppCampaign, services) => {
  /*
     Case 1.  If there are multiple services, returns route object to redirect to -
              1.a SubsequentPromoteServices if isInAppCampaign is true.
              1.b PromoteServices if isInAppCampaign is false.
     Case 2. If there is single service, returns route object to redirect to -
              2.a SubsequentExtractOfferDetails if isInAppCampaign is true.
              2.b ExtractOfferDetails if isInAppCampaign is false.
  */
  var routeObj = {};
  var routeName = isInAppCampaign ? bizgainOnboardingRoutes.SubsequentExtractOfferDetails.name : bizgainOnboardingRoutes.ExtractOfferDetails.name;
  routeObj = { launchState: launchState.OFFER, route: routeName };
  return routeObj;
}

export const validatePhoneNumber = (phoneNumber) => {
  try {
    // got regex from here https://stackoverflow.com/questions/22378736/regex-for-mobile-number-validation
    if (!phoneNumber.match(/^(\+?\d{1,4})?\d([ \-]?\d){5,15}$/))
    {
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

export const getSignupRouteFromLaunchState = (campaignLaunchState, params) => {
  let routeName;
  switch (campaignLaunchState) {
    case launchState.BUSINESSLOCATION: routeName = bizgainOnboardingRoutes.BusinessLocationDetails.name; break;
    case launchState.BUSINESSPHONENUMBER: routeName = bizgainOnboardingRoutes.BusinessPhoneNumber.name; break;
    case launchState.BUSINESSTYPESERVICES: routeName = bizgainOnboardingRoutes.BusinessTypeServices.name; break;
    case launchState.BUSINESSDETAILSANIMATION: routeName = bizgainOnboardingRoutes.BusinessDetailsAnimation.name; break;
    case launchState.GENDER: routeName = bizgainOnboardingRoutes.SelectGender.name; break;
    case launchState.OBJECTIVE: routeName = bizgainOnboardingRoutes.SelectObjective.name; break;
    case launchState.PROMOTESERVICES: routeName = bizgainOnboardingRoutes.PromoteServices.name; break;
    case launchState.OFFER: routeName = bizgainOnboardingRoutes.ExtractOfferDetails.name; break;
    case launchState.CREATIVES: routeName = bizgainOnboardingRoutes.ImageCreatives.name; break;
    case launchState.CREATIVESPREVIEW: routeName = bizgainOnboardingRoutes.ImageCreativesCreativePreview.name; break;
    case launchState.CREATIVESEDIT:routeName =  bizgainOnboardingRoutes.ImageCreativesCreativeEdit.name; break;
    case launchState.FACEBOOKADPREVIEW:routeName = bizgainOnboardingRoutes.ImageCreativesAdPreview.name; break;
    case launchState.FACEBOOKADEDIT: routeName = bizgainOnboardingRoutes.ImageCreativesAdDetailsEdit.name; break;
    case launchState.GOOGLEADPREVIEW: routeName = bizgainOnboardingRoutes.GoogleAds.name; break;
    case launchState.GOOGLEADEDIT: routeName = bizgainOnboardingRoutes.GoogleAdsEdit.name; break;
    case launchState.SIGNUP: routeName = bizgainOnboardingRoutes.EmailSignup.name; break;
    case launchState.AGEGENDERTARGETING: routeName = bizgainOnboardingRoutes.AgeGenderTarget.name; break;
    case launchState.LOCATIONTARGETING: routeName = bizgainOnboardingRoutes.LocationTargeting.name; break;
    case launchState.BUDGET: routeName = bizgainOnboardingRoutes.Budget.name; break;
    //shorten flow
    case launchState.TARGETINGV2: routeName = bizgainOnboardingRoutes.TargetingV2.name; break;
    case launchState.BusinessDetailsV2: routeName = bizgainOnboardingRoutes.BusinessDetailsV2.name; break;
    case launchState.BusinessDetailsSetupAnimationV2: routeName = bizgainOnboardingRoutes.BusinessDetailsSetupAnimationV2.name; break;
    case launchState.CreativeDetailsV2: routeName = bizgainOnboardingRoutes.CreativeDetailsV2.name; break;
  }
  if (!routeName) {
    return;
  }
  return { name: routeName, params: { ...params } };
}

export const getDimensionOfImage = async (src) => {
  return new Promise((resolve, reject)=>{
    let img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  })
}